/**
 * Whether an element resolves an accessible name from the three sources an icon button can
 * legitimately use: visible text, `aria-label`, or `aria-labelledby` pointing at a non-empty
 * element. This is deliberately narrower than the full accname algorithm — it exists to catch
 * the one failure mode an icon-only button has, which is carrying no name at all.
 */
export function hasAccessibleName(element: Element): boolean {
  const ariaLabel = element.getAttribute('aria-label');

  if (ariaLabel !== null && ariaLabel.trim() !== '') {
    return true;
  }

  const labelledBy = element.getAttribute('aria-labelledby');

  if (labelledBy !== null && labelledBy.trim() !== '') {
    // ownerDocument rather than getRootNode(): this runs during SSR too, and the server-side
    // DOM shim does not implement getRootNode.
    const root = element.ownerDocument;
    const named = labelledBy
      .trim()
      .split(/\s+/)
      .some((id) => (root.getElementById(id)?.textContent ?? '').trim() !== '');

    if (named) {
      return true;
    }
  }

  return (element.textContent ?? '').trim() !== '';
}
